// extracted by mini-css-extract-plugin
export var tabIcon = "styles-module__tabIcon___yLULf";
export var tab = "styles-module__tab___MPHFe";
export var active = "styles-module__active___owWG_";
export var tabBar = "styles-module__tabBar___CwfC2";